<template>
  <div>
    <h1 class="text-h1 mb-16">Your Premium access is ready</h1>
    <p class="pb-16 text-body text-grey-body">Please log in to the Sittercity account associated with:</p>
    <p v-if="maskedMemberEmail" class="pb-16 text-body text-grey-body">
      <strong>{{ maskedMemberEmail }}</strong>
    </p>
    <p class="pb-16 text-body text-grey-body">
      Once logged in, your employer-sponsored Premium access will be available automatically.
    </p>
    <Button class="w-full" variant="primary" value="Log in now" size="medium" :href="loginUrl" />
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';

export default {
  name: 'VerifyCorporateUpgradeLoggedOut',
  components: {
    Button,
  },
  props: {
    maskedMemberEmail: {
      type: String,
      default: '',
    },
    loginUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
